<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import PtwBackButton from '@/components/buttons/PtwBackButton.vue';
import MedicalSystemForm from './components/MedicalSystemForm.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import { api } from '@/api';
import { routenames } from '@/router/routenames';
import { computed, onMounted } from 'vue';
import { type MedicalSystemRtSystemDto } from '@/api/generator';
import { useLoading } from '@/utils/useLoading';
import BasePageStatus from '@/components/pages/BasePage/BasePageStatus.vue';
import { getMedicalSystemSubtitle } from './utils';
import { entityNotFoundErrorHandler } from '@/errorHandling';
import { useRouter } from 'vue-router';

const props = defineProps<{
  id: string;
}>();

const {
  form: { values, resetForm },
} = useVeeForm<MedicalSystemRtSystemDto>({
  mode: 'details',
});

const router = useRouter();

const { action: loadInitialValues, loading } = useLoading(async () => {
  const { success, result } = await api.medicalSystemsApi.getMedicalSystemRtSystem(props, [
    entityNotFoundErrorHandler(router),
  ]);
  if (success) resetForm({ values: result });
}, true);

const subtitle = computed(() => getMedicalSystemSubtitle(values));

onMounted(loadInitialValues);
</script>

<template>
  <BasePage :loading="loading">
    <template #title>
      <BasePageTitle :title="values.name" :subtitle="subtitle" :titleId="values.iuid" />
    </template>

    <template #status>
      <BasePageStatus :entity="values" />
    </template>

    <template #actions>
      <PtwBackButton :to="{ name: routenames.medicalSystems.overview }" />
    </template>

    <MedicalSystemForm />
  </BasePage>
</template>
